// extracted by mini-css-extract-plugin
export default {"block":"style_block__ZRqYs","opacity":"style_opacity__q7q2m","opacityIsDraggin":"style_opacityIsDraggin__oIc+f"};